import { createRoot } from 'react-dom/client';

// Renders `Component` into the element with the given id, passing any
// JSON found in its `data-props` attribute. Does nothing if the element is absent.
const mountComponent = (mountPointId, Component) => {
  const mountPoint = document.getElementById(mountPointId);
  if (!mountPoint) return;

  const props = JSON.parse(mountPoint.dataset.props || '{}');
  createRoot(mountPoint).render(<Component {...props} />);
};

export default mountComponent;
